import { CategoryImage } from './api/ImageType';

export interface ICategory {
  title: string;
  hexColor?: string;
  image?: CategoryImage;
}

/**
 * Returning the first hexcolor configured in an array of categories.
 * First category always takes priority
 */
export function getHexColor(categories?: ICategory[]): string | undefined {
  return categories?.length === 1 ? categories[0].hexColor : undefined;
}
